/**
 * 라우트 param · URL query 의 숫자 파싱 SSoT — 상세 페이지 id·목록 page·필터 id 가 공유한다.
 * 검증 실패는 null(또는 0)로 돌려주고, "찾을 수 없음" 처리는 호출부(useNotFoundRedirect)가 맡는다.
 * 쿼리 훅의 `enabled` 로 불량 값을 조용히 삼키지 않는다 — 삼키면 영구 pending(무한 로딩)이 된다.
 */

/** 양의 정수 id. 비숫자·0·음수·소수는 null. */
export function parsePositiveInt(raw: string | null | undefined): number | null {
  const n = Number(raw);
  return Number.isInteger(n) && n > 0 ? n : null;
}

/** 0 이상 정수 페이지(0-based). 그 외(음수·NaN·소수)는 0. */
export function parsePage(raw: string | null | undefined): number {
  const page = Number(raw);
  return Number.isInteger(page) && page > 0 ? page : 0;
}
